module.exports = __webpack_public_path__ + "static/GalaxieCopernicus-SemiboldItalic-bbba3b0b11422cc764e07c75c8dcbcab.woff2";